export default __webpack_public_path__ + "13c1271ce9a2d862a6e8e2384fd1c854.png";